import { CountryConfig } from "../../shared/types";
import { philippinesFormRegistry } from "./formRegistry";
import { PHP_DATA_SLICE_KEY } from "./const";
import { ReactComponent as PhilippinesFlag } from "../../assets/phillipines-flag.svg";

export const philippinesConfig: CountryConfig = {
  code: "PHP",
  name: "Philippines",
  dataSliceKey: PHP_DATA_SLICE_KEY,
  flag: PhilippinesFlag,
  currencyCode: "PHP",
  formRegistry: philippinesFormRegistry,
  paymentMethods: [
    { name: "Bank transfer", value: "bank" },
    { name: "eWallet", value: "wallet" },
  ],
  steps: [
    {
      id: "amount",
      type: "amount",
      title: "Amount",
      stepTitle: "How much are you sending?",
    },
    {
      id: "payment_details",
      type: "payment_details",
      title: "Payment Details",
      stepTitle: "Payment Details",
    },
    {
      id: "beneficiary",
      type: "beneficiary",
      title: "Beneficiary",
      stepTitle: "Beneficiary details",
    },
    {
      id: "review",
      type: "review",
      title: "Review",
      stepTitle: "Review the details of your transaction",
    },
  ],
};
